import axios from 'axios';
 

export const getMisson = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}vissionmission`); 
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;
  }
};
